import {
  Box,
  Grid,
  IconButton,
  Menu,
  Typography,
} from "@material-ui/core/";
import {
  ThemeProvider,
  createStyles,
  makeStyles,
} from "@material-ui/core/styles";

import { AccountCircleOutlined } from "@material-ui/icons";
import { Stamp } from "../components-atoms";
import React from "react";
import { signOutAndClearReducers } from "../redux/actions/signOutAndClearAllReducers";
import { colours, theme } from "../constants/theme";
import tradeKartLogo from "../assets/icons/tradeKartLogo.svg";
import { useDispatch, useSelector } from "react-redux";
import { useAppWebSocket } from "../hooks/useAppWebSocket";
import LogoutButton from "./LogoutButton";
import { useTranslation } from "react-i18next";

interface IPortalName {
  Admin: string;
  Merchant: string;
  Shop: string;
}


interface SocketMessage {
  HasCredits: boolean;
  RemainingCredits: number;
}

function Header(props: any) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const [role, shopName, merchantLogo, interval, notificationInterval] =
    useSelector((state: any) => [
      state.login.role,
      state.login.shopName,
      state.login.merchantLogo,
      state.OrderInterval.interval,
      state.notificationOrderInterval.interval
    ]);

  const { lastJsonMessage } = useAppWebSocket<SocketMessage>(
    '/ws/remaining-credits',
    {
    },
    role === "Shop"
  );

  const handleClose = () => {
    setAnchorEl(null);
  };
  const signOut = () => {
    clearInterval(interval);
    clearInterval(notificationInterval);
    dispatch(signOutAndClearReducers());
    if ((window as any).HubSpotConversations && (window as any).HubSpotConversations.widget) {
      (window as any).HubSpotConversations.widget.remove();
    }
  };
  const portalName: IPortalName = {
    Admin: t('header.adminTool'),
    Merchant: t('header.merchantPortal'),
    Shop: t('header.shopPortal'),
  };
  return (
    <Box className={classes.container}>
      <ThemeProvider theme={theme}>
        <Grid container className={classes.subContainer}>
          <Grid item xs={9}>
            <a href="/" className={classes.backToHomeLink}>
              <img
                src={tradeKartLogo}
                style={{ width: "156px", height: "36px" }}
                alt="TradeKart logo"
              />
              <div className={classes.divider} />
              <Typography
                className={classes.secondaryTitle}
                variant="h6"
                component="p"
              >
                {role ? portalName[role] : t('header.shopPortal')}
              </Typography>
              {merchantLogo && (
                <>
                  <div className={classes.divider} />

                  <img
                    src={merchantLogo}
                    className={classes.merchantLogo}
                    alt="Merchant logo"
                  />
                </>
              )}
              {!merchantLogo && <div className={classes.divider} />}
              <Typography
                className={classes.secondaryTitle}
                variant="h6"
                component="p"
              >
                {shopName && shopName}
              </Typography>
            </a>
          </Grid>

          {props?.isLoggedIn && (
            <Grid item xs={3} className={classes.subContainerEnd}>
              <Box display="flex" flex={1} justifyContent="flex-end" alignItems="center">
                {(role === "Shop" && lastJsonMessage?.HasCredits) ? (
                  <Stamp
                    text={`${lastJsonMessage.RemainingCredits} credits left`}
                    type={lastJsonMessage.RemainingCredits > 10 ? 'primary' : 'fail'}
                  />
                ) : null}
              </Box>


              <IconButton
                id="user-profile-button"
                aria-label="User profile"
                aria-controls={open ? "user-profile-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
              >
                <AccountCircleOutlined htmlColor="#fff" />
              </IconButton>
              <Menu
                id="user-profile-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "user-profile-button",
                  role: "listbox",
                }}
                className={classes.menu}
              >
                <LogoutButton
                  variant="text"
                  color="default"
                  size="small"
                  logoutAllDevices={false}
                  onLogout={signOut}
                  compact={true}
                />
              </Menu>
            </Grid>
          )}
        </Grid>
      </ThemeProvider>
    </Box>
  );
}

export default Header;
const useStyles = makeStyles(
  createStyles({
    container: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      zIndex: 1201,
      display: "flex",
      backgroundColor: colours.highEmphasis,
    },
    subContainer: {
      height: 64,
      alignItems: "center",
      paddingLeft: 24,
      paddingRight: 24,
    },
    subContainerEnd: {
      display: "flex",
      alignItems: 'center',
    },
    backToHomeLink: {
      display: "inline-flex",
      alignItems: "center",
      textDecoration: "none",
    },
    title: {
      color: "rgba(255, 255, 255, 1)",
      fontWeight: 700,
      alignSelf: "center",
      marginLeft: "20px",
      marginRight: "20px",
    },
    secondaryTitle: {
      color: colours.primary,
      alignSelf: "center",
    },
    divider: {
      position: "static",
      width: "1px",
      height: "36px",
      left: "128px",
      top: "0px",
      alignSelf: "center",
      marginLeft: 20,
      marginRight: 20,
      background: "rgba(255, 255, 255, 0.38)",
    },
    menu: {
      marginTop: 40,
      borderRadius: 12,
    },
    root: {
      width: 256,
      padding: "12px 4px",
      borderRadius: 12,
    },
    merchantLogo: {
      width: 36,
      height: 36,
      borderRadius: 4,
      marginRight: 8,
      backgroundColor: "#fff",
    },
  })
);
